import {Navigate, Route, Routes, useLocation, useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {toast, ToastContainer} from "react-toastify";
import {Loader} from "./Components/Loader";
import {useEffect, useState} from "react";
import {SignIn} from "./Screens/SignIn";
import './Scss/main.scss'
import "react-toastify/dist/ReactToastify.css";
import PrivateRoute from "./Route/PrivatRoute";
import {Users} from "./Screens/Users";
import {NavBar} from "./Components/NavBar";
import jwtDecode from "jwt-decode";
import {Avatars} from "./Screens/Avatars";
import {Words} from "./Screens/Words";

export const App = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const loader = useSelector((state) => state.loaderReducer);
  const toastState = useSelector((state) => state.toastReducer);
  const token = localStorage.getItem('userToken')
  const [decode, setDecode] = useState(null)

  useEffect(() => {
    notify();
  }, [toastState]);

  useEffect(() => {
    if(localStorage.getItem('userToken')) {
      setDecode(jwtDecode(localStorage.getItem('userToken')))
    }
    if (location.pathname === '/') {
      navigate('/login')
    }
  }, [token])

  const notify = () => {
    if (toastState.show) {
      return toast[toastState.type](<Msg />, toastState.settings);
    }
  };

  const Msg = ({ closeToast }) => (
    <div>
      <h4 className={'toastText'}>{toastState.title}</h4>
      <p className={'toastText'}>{toastState.text}</p>
    </div>
  );

  return (
    <>
      {loader.show && <Loader />}
      {toastState.show && <ToastContainer />}
      {localStorage.getItem('userToken') && <NavBar profile={decode}/>}
      <Routes>
        <Route path={'/login'} element={<SignIn/>}/>
        <Route path={'/users'} element={
          <PrivateRoute>
            <Users/>
          </PrivateRoute>
        }/>
        <Route path={'/default-avatars'} element={
          <PrivateRoute>
            <Avatars/>
          </PrivateRoute>
        }/>
        <Route path={'/words'} element={
          <PrivateRoute>
            <Words/>
          </PrivateRoute>
        }/>
      </Routes>
    </>
  );
}
